import React, { useState, useContext } from "react";
import { Row, Col, Modal } from "react-bootstrap";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { useNavigate, useLocation } from "react-router-dom";
import HandleHttpErrors from "../../HandleHttpErrors";
import useAuth from "../../../hooks/useAuth";
//import ModalS from "../../ErrorModal";
import { MdLiveHelp } from "react-icons/md";
import HelpModal from "../../shared/HelpModal";
import HelpContext from "../../shared/context/HelpProvider";

export default function Add({
  increment,
  counter,
  mekhraz,
  setMekhrazUpdated,
}) {
  var today = new Date(),
    date =
      today.getFullYear() +
      "-" +
      (today.getMonth() + 1) +
      "-" +
      today.getDate();
  const { showHelp, setShowHelp, saeef, setSaeef } = useContext(HelpContext);
  const { auth } = useAuth();
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const location = useLocation();
  const [newExt, setNewExt] = useState({
    ext_date: null,
    previous_date: mekhraz.hagsha_date,
    notes: "",
    mekhraz: mekhraz.id,
    log_created_at: today,
  });
  const handleChange = (e) => {
    e.preventDefault(); // prevent the default action
    const { name, value } = e.target;

    setNewExt((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();

    const addData = async () => {
      try {
        const response = await axiosPrivate.post("/jobs/extention/", newExt, {
          signal: controller.signal,
        });
        if (isMounted) {
          increment();
          setMekhrazUpdated((prev) => !prev);
          setNewExt({
            ext_date: null,
            previous_date: mekhraz.hagsha_date,
            notes: "",
            mekhraz: mekhraz.id,
            log_created_at: today,
          });
          alert("ההארכה בוצעה בהצלחה");
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    addData();
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  };

  return (
    <div>
      <HelpModal />
      <center>
        <div className="card text-dark bg-light container p-3  border">
          <div className="card-header">
            <h3
              onClick={() => {
                setSaeef("5");
                setShowHelp(true);
              }}
            >
              הארכות של המכרז: {mekhraz.title}
              <span className="help">
                <MdLiveHelp />
              </span>
            </h3>
          </div>
          <div className="card-body">
            <Row>
              <Col>
                <form onSubmit={handleSubmit} className="mbsc-form-group">
                  <div className="form-group">
                    <label htmlFor="ext_date">מועד הגשה חדש</label>
                    <input
                      type="date"
                      name="ext_date"
                      value={newExt.ext_date}
                      onChange={handleChange}
                      className="form-control"
                      id="ext_date"
                      placeholder="22-8-2022"
                    />
                    <p id="uidnote" className="instructions">
                      {" "}
                      במכרז פומבי ייקבע פרק זמן להגשת בקשות להשתתף במכרז לתקופה
                      <br />
                      שלא תהיה קצרה מארבעה עשר ימים ולא תהיה ארוכה מארבעים ושנים
                      יום
                    </p>
                  </div>
                  <label htmlFor="notes">הערות </label>
                  <textarea
                    name="notes"
                    value={newExt.notes}
                    onChange={handleChange}
                    className="form-control"
                    id="notes"
                    placeholder="חובה לתעד סיבת ההארכה"
                    required
                  />
                  <br />
                  <button type="submit" className="btn btn-primary">
                    אישור הארכה חדשה
                  </button>
                </form>
              </Col>
            </Row>
          </div>
        </div>
      </center>
    </div>
  );
}
